var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmphasis(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0536 16.5L8.97049 15.7123L10.5213 13.1523L7.86279 12.0446L8.28125 10.7892L11.0874 11.4785L11.3336 8.5H12.6628L12.9089 11.4538L15.7151 10.7892L16.1336 12.0446L13.4505 13.1523L15.0259 15.7123L13.9428 16.5L11.9982 14.1615L10.0536 16.5Z",
    fill: "#838383"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmphasis);
export default __webpack_public_path__ + "static/media/emphasis.fe0bf7bf8e7ff07335c903fde91117ed.svg";
export { ForwardRef as ReactComponent };